function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import { Form } from 'react-bootstrap';
import { useSelector } from 'react-redux';

// works if rendered in a component, where the IsUnderReviewContext is provided
export default function ImmutableUnderReviewFormControl(_ref) {
  let {
    className = '',
    disabled = false,
    as = 'input',
    ...props
  } = _ref;
  const isUnderTechnicalReview = useSelector(state => state.review.isUnderTechnicalReview);
  const isDisabled = disabled || isUnderTechnicalReview;
  return /*#__PURE__*/React.createElement(Form.Control, _extends({
    as: as,
    className: `${className} ${isDisabled ? 'disabled' : ''}`
  }, props, {
    disabled: isDisabled
  }));
}